import React from 'react';
import _ from 'lodash';
import csvParse from 'csv-parse/lib/sync';
import { Route } from 'react-router-dom';
import HeaderThin from 'app/components/layout/HeaderThin';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ProgressIndicator, { IStep } from 'app/components/general/ProgressIndicator';

import * as organisationsActions from 'app/ducks/organisations/actions';
import * as connectionsActions from 'app/ducks/connections/actions';
import * as competitionsActions from 'app/ducks/competitions/actions';
import * as fixtureMatchImportsActions from 'app/ducks/fixtureMatchImports/actions';
import * as connectionRunsActions from 'app/ducks/connectionRuns/actions';

import * as connectionSelectors from 'app/ducks/connections/selectors';
import * as organisationSelectors from 'app/ducks/organisations/selectors';
import * as competitionSelectors from 'app/ducks/competitions/selectors';
import * as fixtureMatchImportSelectors from 'app/ducks/fixtureMatchImports/selectors';
import * as connectionRunSelectors from 'app/ducks/connectionRuns/selectors';

import UploadFile from './UploadFile';
import MapFields from './MapFields';
import Review from './Review';


function selector(state): any {
  return {
    connections: connectionSelectors.getConnections(state),
    organisations: organisationSelectors.getOrganisations(state),
    competitions: competitionSelectors.getCompetitions(state),
    fixtureMatchImports: fixtureMatchImportSelectors.getFixtureMatchImports(
      state,
    ),
    connectionRuns: connectionRunSelectors.getConnectionRuns(state),
  };
}

const actionCreators = _.merge(
  connectionsActions,
  organisationsActions,
  competitionsActions,
  fixtureMatchImportsActions,
  connectionRunsActions,
);

interface IImportMatchPaymentsProps {
  appReady: boolean;
  actions: any;
  organisations: any;
  competitions: any;
  connectionRuns: any;
  fixtureMatchImports: any;
  match: any;
  errors: any;
}

interface IImportMatchPaymentsState {
  fileContent: any;
  availableFields: any;
  exampleRecord: any;
  competitionSelection: any;
  errors: any;
}

@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class ImportMatchPayments extends React.Component<
  IImportMatchPaymentsProps,
  IImportMatchPaymentsState
> {
  static defaultProps: IImportMatchPaymentsProps = {
    appReady: false,
    actions: undefined,
    organisations: {},
    competitions: {},
    connectionRuns: {},
    fixtureMatchImports: {},
    match: undefined,
    errors: undefined,
  };

  state: IImportMatchPaymentsState = {
    fileContent: null,
    availableFields: [],
    exampleRecord: null,
    competitionSelection: undefined,
    errors: {},
  };

  componentDidMount = (): void => {
    this.props.actions.getAllConnections();
    this.props.actions.getAllCompetitions();
  };

  extractHeaderColumns = (fileContent): any => {
    const records = csvParse(fileContent, {
      columns: true,
      skip_empty_lines: true,
      skip_lines_with_error: true,
    });
    const exampleRecord = records[0];
    const headerColumns = _.keys(exampleRecord);
    return [exampleRecord, headerColumns];
  };

  changeFileContent = (newContent): void => {
    const [exampleRecord, headerColumns] = this.extractHeaderColumns(
      newContent,
    );

    this.setState({
      fileContent: newContent,
      availableFields: headerColumns,
      exampleRecord,
    });
  };

  handleCompetitionChange = (e) => {
    if (e && e.id != null) {
      this.setState(() => ({
        competitionSelection: e,
      }));
    }
  }

  render(): React.ReactNode {
    const steps: IStep[] = [
      {
        number: 1,
        text: 'Upload file',
        complete: this.props.match.url !== '/import/match-payments',
        active: this.props.match.url === '/import/match-payments',
      },
      {
        number: 2,
        text: 'Map fields',
        complete: _.includes(['/import/match-payments/review/:connectionRunId'], this.props.match.path),
        active: this.props.match.url === '/import/match-payments/map',
      },
      {
        number: 3,
        text: 'Review import',
        complete: false,
        active: this.props.match.path === '/import/match-payments/review/:connectionRunId',
      },
    ];
    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin
              title="Import Match Payments from a CSV"
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <ProgressIndicator steps={steps} />
          </div>
        </div>
        <div className="row with-margin-top">
          <div className="col">
            <Route
              exact
              path="/import/match-payments"
              render={(): React.ReactNode => (
                <UploadFile
                  {...this.props}
                  {...this.state}
                  changeFileContent={this.changeFileContent}
                  handleCompetitionChange={this.handleCompetitionChange}
                  competitionSelection={this.state.competitionSelection}
                />
              )}
            />

            <Route
              exact
              path="/import/match-payments/map"
              render={(): React.ReactNode => (
                <MapFields
                  {...this.props}
                  {...this.state}
                  fileContent={this.state.fileContent}
                />
              )}
            />
            <Route
              exact
              path="/import/match-payments/review/:connectionRunId"
              render={(): React.ReactNode => (
                <Review
                  {...this.props}
                  {...this.state}
                />
              )}
            />
          </div>
        </div>
      </div>
    );
  }
}
